<template>
  <div class="sign-up">
    <h1 class="header">Create an Account</h1>
    <div class="illustration">
      <img src="../assets/illust.svg" alt="">
    </div>
    <div class="form">
      <input v-model="email" placeholder="Email" />
      <br />
      <input type="password" v-model="password" placeholder="Password" />
      <br />
      <button @click="signUp">Sign Up</button>
      <p>
        or go back to
        <router-link to="/login">login</router-link>.
      </p>
    </div>
  </div>
</template>

 <script>
import firebase from "firebase";
export default {
  name: "signUp",
  props: ["api"],
  data() {
    return {
      email: "",
      password: ""
    };
  },
  methods: {
    signUp: function() {
      firebase
        .auth()
        .createUserWithEmailAndPassword(this.email, this.password)
        .then(
          user => {
            this.$router.replace("home");
          },
          err => {
            alert("Oops. " + err.message);
          }
        );
    }
  }
};
</script>

 <style scoped lang="scss">
.sign-up {
  /* margin-top: 40px; */

  .illustration{
    text-align: center;
    padding: 2rem 0 5rem 0;
    img{
    
      width: 20rem;
    }
  }
  .header {
    font-family: var(--sans);
    padding: 0 2rem;
  }

  .form {
    text-align: center;
  }
}
input {
  margin: 10px 0;
  width: 60%;
  padding: 15px;
  -webkit-appearance: none;
  box-shadow: none;
  outline: none;
  border: 1px solid #bbb;
}
button {
  margin-top: 20px;
  /* width: 10%; */
  cursor: pointer;
}
p {
  margin-top: 40px;
  font-size: 1rem;
  font-family: var(--serif);
}
p a {
  text-decoration: underline;
  cursor: pointer;
}
</style>